module.exports = __webpack_public_path__ + "img/2.56b55bbd.jpg";